$(function() {
    if($('.wpcf7-form').length > 0) {

        let $input = $('input#newsletter-input'),
            $label = $('label.email-label')

        $input.on('focus click', function(){
            $label.addClass('active')
        })

        $input.on('blur', function(){
            if($(this).val() == '') {
                $label.removeClass('active')
            }
        })

        $input.on('input autocomplete', function() {
            if ($(this).val() != '') {
                $label.addClass('active');
            } else {
                $label.removeClass('active');
            }
        })
    }
})